import { motion } from "framer-motion";

const txtVariant = {
  initial: {
    y: "100%",
  },
  animate: {
    y: 0,
    transition: {
      ease: [0.6, 0.01, -0.05, 0.95],
      duration: 1.5,
    },
  },
};



export default function About() {
  return (
    <section className="main-section" id="about">
      <div className="subheading">
        <div className="overlay-div">
          <motion.h2
            className="two"
            variants={txtVariant}
            initial="initial"
            whileInView="animate"
            viewport={{ once: true }}
          >
            About
          </motion.h2>
        </div>
        <div className="overlay-div">
          <motion.h2
            className="three"
            variants={txtVariant}
            initial="initial"
            whileInView="animate"
            viewport={{ once: true }}
          >COMPANY</motion.h2>
        </div>
      </div>

      <div className="about-layout top-border">
        <div className="right-col">
          <div className="text-container">
            <div className="about-content">
              <h3>S.N.S. Glass House <br /> Premium Glass & uPVC Solutions in Chhatarpur, Delhi</h3>
              <p>
                S.N.S. Glass House is a leading glass and aluminium solutions provider based in Chhatarpur, Delhi. We specialize in high-quality toughened glass, uPVC windows & doors, aluminium systems, shower partitions, mirrors, glass blocks, and modern architectural glass works for residential, commercial, and industrial projects.
              </p>
              <p>
                With years of experience and a strong commitment to quality, we deliver durable, stylish, and customized glass solutions that enhance the safety, comfort, and beauty of every space.
              </p>

              <h3>Our Services</h3>
              <p>We offer a wide range of premium products and installation services, including:</p>
              <ul>
                <li>Toughened & laminated glass</li>
                <li>uPVC windows and doors</li>
                <li>Aluminium sliding & telescopic systems</li>
                <li>Slim glass partitions</li>
                <li>Shower enclosures & bathroom partitions</li>
                <li>Glass doors & railings</li>
                <li>Designer mirrors & glass blocks</li>
                <li>Commercial glass façades</li>
              </ul>
              <p>
                Whether it’s a home renovation, office setup, showroom, or commercial project, S.N.S. Glass House provides tailor-made solutions that match your design and functional needs.
              </p>

              <h3>Why Choose S.N.S. Glass House?</h3>
              <ul>
                <li><strong>Premium Quality Materials</strong> – Long-lasting and weather-resistant</li>
                <li><strong>Expert Installation Team</strong> – Skilled professionals with precision work</li>
                <li><strong>Modern Designs</strong> – Stylish and space-efficient solutions</li>
                <li><strong>Affordable Pricing</strong> – Best value for money</li>
                <li><strong>Timely Delivery</strong> – On-time project completion</li>
                <li><strong>Customer Satisfaction</strong> – Trusted by clients across Delhi NCR</li>
              </ul>

              <h3>Our Mission</h3>
              <p>
                Our mission is to deliver reliable, modern, and innovative glass solutions that add value to every property while maintaining high standards of safety and craftsmanship.
              </p>

              <h3>Our Vision</h3>
              <p>
                To become the most trusted glass and uPVC solutions brand in Delhi NCR, known for quality, service, and customer satisfaction.
              </p>

              <h3>Serving Chhatarpur & Delhi NCR</h3>
              <p>
                We proudly serve clients in Chhatarpur, South Delhi, Saket, Vasant Kunj, Mehrauli, Gurgaon, Noida, and nearby areas, offering complete glass and aluminium solutions under one roof.
              </p>
            </div>
          </div>
        </div>
      </div>

      <section className="client-carousel-section">
        <h3>Our Clients</h3>
        <div className="client-carousel-container">
          <div className="client-carousel-track">
            {/* First set of clients */}
            {[
              "client-baani.webp",
              "client-bacardi.webp",
              "client-bazar.webp",
              "client-cinemas.webp",
              "client-citywalk.webp",
              "client-court.webp",
              "client-da-milano.webp",
              "client-dlf.webp",
              "client-igi.webp",
              "client-imagine.webp",
              "client-jhonson.webp",
              "client-jhs.webp",
              "client-mp.webp",
              "client-narulas.webp",
              "client-pap.webp",
              "client-powergrid.webp",
              "client-relience.webp",
              "client-salon.webp",
              "client-tanishq.webp",
              "client-tke.webp",
            ].map((client, index) => (
              <div key={`client-1-${index}`} className="client-slide">
                <img src={`/images/${client}`} alt="client logo" />
              </div>
            ))}
            {/* Duplicate set for infinite scroll */}
            {[
              "client-baani.webp",
              "client-bacardi.webp",
              "client-bazar.webp",
              "client-cinemas.webp",
              "client-citywalk.webp",
              "client-court.webp",
              "client-da-milano.webp",
              "client-dlf.webp",
              "client-igi.webp",
              "client-imagine.webp",
              "client-jhonson.webp",
              "client-jhs.webp",
              "client-mp.webp",
              "client-narulas.webp",
              "client-pap.webp",
              "client-powergrid.webp",
              "client-relience.webp",
              "client-salon.webp",
              "client-tanishq.webp",
              "client-tke.webp",
            ].map((client, index) => (
              <div key={`client-2-${index}`} className="client-slide">
                <img src={`/images/${client}`} alt="client logo" />
              </div>
            ))}
          </div>
        </div>
        <p className="client-carousel-description">Certain projects were executed through authorized intermediaries.</p>
      </section>
    </section>
  );
}
